exports = module.exports = require("../../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GF8YGzk2_s9UJ92SnhVj_{position:absolute;top:1.78571rem;left:0;width:100%;z-index:2;z-index:10}.GF8YGzk2_s9UJ92SnhVj_ .is-open .Select-arrow{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg)}.GF8YGzk2_s9UJ92SnhVj_ .Select-arrow-zone{right:1rem;font-size:.7rem}.GF8YGzk2_s9UJ92SnhVj_ .Select-arrow:before{content:'\\E901';font-size:.7rem}.GF8YGzk2_s9UJ92SnhVj_ .Select-option{font-weight:normal;font-size:.8rem}.GF8YGzk2_s9UJ92SnhVj_ .Select-placeholder{padding-left:1rem;font-weight:normal}.GF8YGzk2_s9UJ92SnhVj_ .Select-placeholder span{color:#757d8c}\n", ""]);

// exports
exports.locals = {
	"disambiguation": "GF8YGzk2_s9UJ92SnhVj_"
};